import React from 'react';

const SignOutBtnComponent = () => {
    return (
        <>
            <div className="p-1">
                <button className='bg-slate-600 rounded-md px-3 py-1.5 text-white'>SIGN OUT</button>
            </div>
        </>
    );
}

export default SignOutBtnComponent;
